export default "__VITE_ASSET__d76b9358__"